<template>
  <button
    class="input-button"
    :class="{ primary, secondary, small, centered, disabled }"
    :type="type"
    @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
  export default {
    name: 'Button',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      type: {
        type: String,
        default: 'button',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      //----------------------------------
      // CSS Related Properties
      //----------------------------------
      primary: {
        type: Boolean,
        default: false,
      },
      secondary: {
        type: Boolean,
        default: false,
      },
      small: {
        type: Boolean,
        default: false,
      },
      centered: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.input-button {
  min-height: 42px;
  min-width: 129px;
  outline: 0;
  padding: 12px 28px;
  @include font-button;
  text-transform: uppercase;
  border: 1px solid transparent;
  border-radius: $default-border-radius;
  background-color: $color-black-alpha-10;
  color: $color-black-alpha-60;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &.small {
    min-height: 0;
    padding: 6px 14px;
  }

  &.centered {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &.primary {
    background-color: $color-blue-solid-100;
    color: $color-white-solid-10;

    &:focus {
      animation: focus-blue-solid-10 0.15s linear forwards;
    }
  }

  &.secondary {
    background-color: $color-white-solid-10;
    border: 1px solid $color-blue-solid-100;
    color: $color-blue-solid-100;

    &:focus {
      animation: focus-blue-solid-10 0.15s linear forwards;
    }
  }
}
</style>
